"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNLOCKING_DURATION = exports.EPOCH_DURATION = exports.PYTH_TOKEN = exports.REALM_ID = exports.STAKING_ADDRESS = exports.GOVERNANCE_ADDRESS = void 0;
const web3_js_1 = require("@solana/web3.js");
function GOVERNANCE_ADDRESS() {
    return new web3_js_1.PublicKey("Di9ZVJeJrRZdQEWzAFYmfjukjR5dUQb7KMaDmv34rNJg");
}
exports.GOVERNANCE_ADDRESS = GOVERNANCE_ADDRESS;
exports.STAKING_ADDRESS = new web3_js_1.PublicKey("2gWf5xLAzZaKX9tQj9vuXsaxTWtzTZDFRn21J3zjNVgu");
// export const WALLET_TESTER_ADDRESS = new PublicKey(
//   "tstPARXbQ5yxVkRU2UcZRbYphzbUEW6t5ihzpLaafgz"
// );
// export const PROFILE_ADDRESS = new PublicKey(
//   "prfmVhiQTN5Spgoxa8uZJba35V1s7XXReqbBiqPDWeJ"
// );
exports.REALM_ID = new web3_js_1.PublicKey("9Waj7NNTzEhyHf1j1F36xgtnXaLoAxVBFhf6VxE9fgaf");
exports.PYTH_TOKEN = new web3_js_1.PublicKey("4LLbsb5ReP3yEtYzmXewyGjcir5uXtKFURtaEUVC2AHs");
exports.EPOCH_DURATION = 3600 * 24 * 7; // 7 day
exports.UNLOCKING_DURATION = 2; // epochs // 2 epochs == 14 days
